module.exports = __webpack_public_path__ + "static/6-44e6d8fa6a955ec55297cf6704fd2297.jpeg";